import { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/tailwind.css';
import App from 'App';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import 'i18n';
import 'react-photo-view/dist/react-photo-view.css';
import { checkAndInitStorageVersion, logStorageStartup } from 'utils/storage';

checkAndInitStorageVersion();
logStorageStartup();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <Suspense
      fallback={
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <LoadingSpinner />
        </div>
      }
    >
      <App />
    </Suspense>
  </StrictMode>,
);
